import React from "react";

const STYLES = {
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "16px",
    borderBottom: "2px solid #333",
    paddingBottom: "8px",
    padding: "8px",
  },
  logoLeft: {
    width: "80px",
    height: "60px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  logoRight: {
    width: "80px",
    height: "60px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  logoImage: {
    width: "75px",
    height: "75px",
    objectFit: "contain",
  },
  headerText: {
    flex: 1,
    textAlign: "center",
    padding: "0 16px",
  },
  universityName: {
    fontSize: "17px",
    fontWeight: "bold",
    margin: "4px 0",
  },
  learningCenter: {
    fontSize: "14px",
    margin: "2px 0",
    fontWeight: "bold",
  },
  location: {
    fontSize: "13px",
    margin: "2px 0",
  },
};

const BookCardHeader = () => {
  return (
    <div style={STYLES.header}>
      {/* Left Logo - University */}
      <div style={STYLES.logoLeft}>
        <img
          src="/images/university-logo.png"
          alt="University Logo"
          style={STYLES.logoImage}
        />
      </div>

      {/* Header Text */}
      <div style={STYLES.headerText}>
        <div style={STYLES.universityName}>ROMBLON STATE UNIVERSITY</div>
        <div style={STYLES.learningCenter}>Learning Resource Center</div>
        <div style={STYLES.location}>Odiongan, Romblon</div>
      </div>

      {/* Right Logo - LRC */}
      <div style={STYLES.logoRight}>
        <img
          src="/images/lrc-logo.png"
          alt="LRC Logo"
          style={STYLES.logoImage}
        />
      </div>
    </div>
  );
};

export default BookCardHeader;
